<section class="card needs-card" aria-labelledby="needs-title" data-testid="shopping-needs">
  <div class="section-heading compact">
    <div class="needs-heading-title">
      <span class="needs-cart-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="22" height="22" focusable="false">
          <path d="M6 7h15l-1.5 8.5H8L6 7Z" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linejoin="round" />
          <path d="M6 7 5 4H2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <circle cx="9" cy="20" r="1.25" fill="currentColor" />
          <circle cx="18" cy="20" r="1.25" fill="currentColor" />
        </svg>
      </span>
      <div class="needs-heading-text">
        @if (!isRenamingBasket) {
        <div class="basket-title-row">
          <h2 id="needs-title" class="basket-title-inline" (click)="startRenamingBasket()"
            [appSavedField]="basketNameSaved"
            [title]="isBasketClosed ? '' : 'לחץ לעריכת שם הסל'">
            {{ basket?.name || 'רשימת קניות' }}
          </h2>
          @if (!isBasketClosed) {
          <button type="button" class="btn-rename-pencil" (click)="startRenamingBasket()"
            aria-label="עריכת שם הסל" title="עריכת שם הסל">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 20h9"></path>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
            </svg>
          </button>
          }
        </div>
        } @else {
        <div class="basket-rename-row">
          <input type="text" class="basket-rename-input" [(ngModel)]="renameBasketText"
            (keydown.enter)="onSaveBasketName()" (keydown.escape)="cancelRenamingBasket()" maxlength="60"
            placeholder="שם הסל..." autofocus />
          <button type="button" class="btn-rename-save" (click)="onSaveBasketName()" [disabled]="savingBasketName"
            title="שמור שם סל" aria-label="שמור">
            ✓
          </button>
          <button type="button" class="btn-rename-cancel" (click)="cancelRenamingBasket()"
            [disabled]="savingBasketName" title="ביטול" aria-label="ביטול">
            ✕
          </button>
        </div>
        }

        <button type="button" class="basket-location-btn" (click)="openLocation.emit()"
          data-testid="location-settings-button"
          [class.has-location]="hasSelectedLocation"
          [class.no-location]="!hasSelectedLocation"
          [attr.aria-label]="hasSelectedLocation ? 'הגדרות סניף להשוואה: ' + selectedBranchLabel : 'בחרו עיר וסניף להשוואה'"
          [title]="hasSelectedLocation ? (selectedBranchLabel + ' - לחץ לשינוי סניף') : 'לחץ לבחירת עיר וסניף להשוואה'">
          <svg class="basket-location-pin" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="basket-location-text" dir="auto">
            {{ hasSelectedLocation ? selectedBranchLabel : 'בחירת עיר וסניף להשוואה' }}
          </span>
        </button>
      </div>
    </div>
    <div class="heading-end">
      @if (!isRenamingBasket) {
      <span class="count-badge" [class.count-bumped]="countBumped" data-testid="shopping-needs-count"
        [attr.aria-label]="totalCartItemsCount + ' פריטים ברשימה'">
        {{ totalCartItemsCount }}
      </span>
      }
      <button type="button" class="btn-basket-share-inline" [class.is-shared]="basket?.groupId"
        data-testid="basket-share-toggle" (click)="toggleShare.emit()"
        [attr.aria-label]="basket?.groupId ? 'שיתוף סל (' + (basket?.groupName || 'קבוצה משותפת') + ')' : 'שתף סל בקבוצה'"
        [title]="basket?.groupId ? 'משותף עם: ' + (basket?.groupName || 'קבוצה משותפת') + ' · לחץ לצפייה בחברים' : 'שתף סל בקבוצה'">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="18" cy="5" r="3"></circle>
          <circle cx="6" cy="12" r="3"></circle>
          <circle cx="18" cy="19" r="3"></circle>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
        </svg>
      </button>
    </div>
  </div>

  @if (!auth.isLoggedIn) {
  <div class="cart-auth-banner" data-testid="cart-auth-banner">
    <div class="cart-auth-banner-content">
      <svg class="cart-auth-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
        stroke-width="2" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
      <div class="cart-auth-text">
        <strong>צופים בסל זמני מהמכשיר</strong>
        <span>כדי לצפות בסל המשותף ולערוך יחד, יש להתחבר לחשבון.</span>
      </div>
    </div>
    <button type="button" class="btn-cart-login" (click)="openLogin.emit()" data-testid="cart-login-button">
      התחברות עם Google
    </button>
  </div>
  }

  @if (!selectedBranchId) {
  <div class="cart-no-branch-banner" data-testid="cart-no-branch-banner">
    <div class="cart-no-branch-content">
      <svg class="cart-no-branch-icon" viewBox="0 0 24 24" width="22" height="22" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 2a8 8 0 0 0-8 8c0 5.25 8 12 8 12s8-6.75 8-12a8 8 0 0 0-8-8z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
      <div class="cart-no-branch-text">
        <strong>לא נבחר סניף להשוואת מחירים</strong>
        <span>בחרו עיר וסניף סופרמרקט כדי לצפות במחירי הפריטים ולחשב סך הכל.</span>
      </div>
    </div>
    <button type="button" class="btn-cart-pick-branch" (click)="openLocation.emit()"
      data-testid="cart-pick-branch-btn">
      בחירת סניף להשוואה
    </button>
  </div>
  }

  @if (isBasketClosed) {
  <div class="basket-closed-alert" data-testid="basket-closed-banner">
    <div class="closed-alert-text">
      <span class="closed-alert-icon" aria-hidden="true">🔒</span>
      <div>
        <strong>הסל סגור לקניות</strong>
        <p>הסל ננעל כדי לשמור על הפריטים. לא ניתן לבצע שינויים עד לפתיחתו מחדש.</p>
      </div>
    </div>
    <button type="button" class="btn-reopen-inline" [disabled]="basketLoading" (click)="reopenBasket.emit()">
      פתח סל מחדש
    </button>
  </div>
  }

  @if (basketOriginBranchMismatch && listUnpricedCount() > 0) {
  <div class="basket-branch-mismatch-banner" data-testid="basket-branch-mismatch-banner">
    <div class="mismatch-banner-content">
      <span class="mismatch-banner-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </span>
      <div class="mismatch-banner-text">
        <strong>סל זה נבנה במקור עבור {{ basketOriginBranchLabel }}</strong>
        <span>{{ listUnpricedCount() }} מוצרים ברשימה אינם נמכרים בסניף הנבחר הנוכחי.</span>
      </div>
    </div>
    <div class="mismatch-banner-actions">
      <button type="button" class="btn-mismatch-switch" (click)="switchBranch.emit()"
        data-testid="mismatch-switch-btn">
        חזור לסניף המקורי
      </button>
    </div>
  </div>
  }

  @if (basketLoading) {
  <p class="empty-state">טוען את הרשימה השמורה…</p>
  } @else if (!basket || basket.needs.length === 0) {
  <p class="empty-state">הרשימה עדיין ריקה. חפשו והוסיפו מוצר ראשון.</p>
  } @else {
  <ul class="need-list">
    @for (need of basket.needs; track trackNeed($index, need)) {
    <li class="need-row" [attr.data-need-id]="need.id">
      <div class="need-row-main">
        @if (hasProductPhoto(need.lockedProductId)) {
        <button type="button" class="need-photo-btn" (click)="openImagePopup(need.lockedProductId!)"
          [attr.aria-label]="'הגדלת תמונה עבור ' + need.requestedText">
          <img class="need-photo" data-testid="need-photo" [src]="productImageUrl(need.lockedProductId!)" alt=""
            (error)="markImageBroken(need.lockedProductId!)" />
        </button>
        @if (imagePopupProductId === need.lockedProductId) {
        <div class="product-photo-popup" data-testid="need-photo-popup" role="dialog"
          aria-modal="true" aria-label="תמונת מוצר מוגדלת" (click)="closeImagePopup($event)">
          <button type="button" class="product-photo-close" aria-label="סגור תמונה"
            (click)="closeImagePopup($event)">
            ×
          </button>
          <img class="product-photo-popup-img" [src]="productImageUrl(need.lockedProductId!)" alt="" />
        </div>
        }
        }

        <div class="need-copy">
          <strong class="need-title" dir="auto">{{ need.requestedText }}</strong>
          @if (need.listLabel && need.listLabel !== need.requestedText) {
          <span class="need-list-badge" dir="auto">{{ need.listLabel }}</span>
          }
          <div class="need-details-row">
            <div class="need-unit-price" data-testid="need-price">
              @if (need.soldByWeight) {
              <span class="need-qty-label">{{ formatNeedQuantity(need.quantity) }} ק״ג &times;</span>
              } @else if (need.quantity > 1) {
              <span class="need-qty-label">{{ formatNeedQuantity(need.quantity) }} &times;</span>
              }
              @if (needCatalogPrice(need); as price) {
              @if (price.promoPrice != null) {
              <span class="shelf-struck">
                {{ formatMoney(price.price, price.currency) }}
              </span>
              <span class="need-promo-price">
                {{ formatMoney(price.promoPrice, price.currency) }}
              </span>
              } @else {
              {{ formatMoney(price.price, price.currency) }}
              }
              } @else if (!need.lockedProductId) {
              <span class="need-pending-badge">טרם נבחר מוצר</span>
              } @else if (!selectedBranchId) {
              <span class="need-price-missing need-price-unselected">לא נבחר סניף</span>
              } @else {
              <span class="need-unstocked-badge" data-testid="need-unstocked-badge">לא נמכר בסניף זה</span>
              }
            </div>
            <app-kg-quantity class="need-stepper"
              [quantity]="need.quantity"
              [soldByWeight]="!!need.soldByWeight"
              [disabled]="isBasketClosed || busyNeedIds.has(need.id) || estimatingNeedIds.has(need.id)"
              [estimating]="estimatingNeedIds.has(need.id)"
              [label]="need.requestedText"
              testId="need-quantity"
              (quantityChange)="quantityChange.emit({ need, quantity: $event })"
              (photo)="weightPhoto.emit({ need, frameJpeg: $event })"
            />
          </div>
        </div>

        <div class="need-end-col">
          <span class="need-line-total">
            @if (needLineTotal(need); as line) {
            {{ formatMoney(line, needCatalogPrice(need)?.currency ?? 'ILS') }}
            }
          </span>

          <button type="button" class="need-remove" data-testid="need-remove" (click)="removeNeed.emit(need)"
            [disabled]="isBasketClosed || busyNeedIds.has(need.id)"
            [attr.aria-label]="'הסרת ' + need.requestedText">
            ×
          </button>
        </div>
      </div>

      @if (selectedBranchId && needCatalogPrice(need) == null && need.lockedProductId) {
      <div class="need-alternatives-container" data-testid="need-alternatives-box">
        @if (loadingAlternatives.has(need.lockedProductId)) {
        <div class="need-alternatives-loading">
          <span class="alt-spin-dot" aria-hidden="true"></span>
          <span>מחפש חלופות זמינות בסניף…</span>
        </div>
        } @else {
        @if (alternativesByProduct.get(need.lockedProductId); as alts) {
        @if (alts.length > 0) {
        <div class="need-alternatives-box">
          <div class="alt-box-header">
            <span class="alt-box-tag">חלופות מומלצות בסניף זה:</span>
          </div>
          <div class="alt-suggestions-list">
            @for (alt of alts; track alt.productId) {
            <div class="alt-suggestion-card" [class.is-swapping]="swappingNeedIds.has(need.id)">
              <div class="alt-media">
                @if (hasProductPhoto(alt.productId)) {
                <img class="alt-thumb" [src]="productImageUrl(alt.productId)" alt=""
                  (error)="markImageBroken(alt.productId)" />
                } @else {
                <span class="alt-initial" aria-hidden="true">{{ (alt.displayName || alt.nameHe || '?').charAt(0)
                  }}</span>
                }
              </div>
              <div class="alt-info">
                <span class="alt-name" dir="auto">{{ alt.displayName || alt.nameHe }}</span>
                <div class="alt-meta">
                  @if (alt.unitQty) { <span>{{ alt.unitQty }}</span> }
                  @if (alt.brandName) { <span>· {{ alt.brandName }}</span> }
                </div>
              </div>
              <div class="alt-action-col">
                <div class="alt-price-wrap">
                  <strong class="alt-price">{{ formatMoney(alt.promoPrice ?? alt.price, alt.currency || 'ILS')
                    }}</strong>
                  @if (alt.promoPrice != null) {
                  <span class="alt-struck">{{ formatMoney(alt.price, alt.currency || 'ILS') }}</span>
                  }
                </div>
                <button type="button" class="btn-swap-alt" (click)="swapWithAlternative.emit({ need, alt })"
                  [disabled]="isBasketClosed || swappingNeedIds.has(need.id)"
                  [attr.aria-label]="'החלף ל-' + (alt.displayName || alt.nameHe)">
                  {{ swappingNeedIds.has(need.id) ? 'מחליף…' : 'החלף' }}
                </button>
              </div>
            </div>
            }
          </div>
        </div>
        } @else {
        <div class="need-alternatives-empty">
          <span>לא נמצאו חלופות אוטומטיות למוצר זה בסניף.</span>
        </div>
        }
        }
        }
      </div>
      }
    </li>
    }
  </ul>
  <div class="need-total" data-testid="shopping-list-total">
    <div class="total-labels">
      <span>סך הכל</span>
      @if (selectedBranchId && basket && basket.needs.length > 0) {
      @if (listUnpricedCount() > 0 && listPricedCount() > 0) {
      <small class="total-partial-note">({{ listPricedCount() }} מתוך {{ basket.needs.length }} מוצרים · {{
        listUnpricedCount() }} לא נמכרים בסניף)</small>
      } @else if (listPricedCount() === 0) {
      <small class="total-partial-note">כלל המוצרים אינם נמכרים בסניף זה</small>
      }
      }
    </div>
    <strong class="need-line-total">
      {{
      !selectedBranchId
      ? 'לא נבחר סניף'
      : listTotal() == null
      ? 'אין מחיר'
      : formatMoney(listTotal(), listCurrency())
      }}
    </strong>
  </div>
  }
</section>
